import request from '@/utils/request.js'
// 获得证书列表
export const getCertificateList = data => {
  return request({
    method: 'POST',
    url: '/api/yalimedia.user/posterlist',
    data
  })
}
